export const cignaUrl =
  'https://sarhcpdir.cigna.com/web/public/consumer/directory/search?consumerCode=HDC011'

export const getCigna = (memberDTO: any) => {
  const isCigna =
    memberDTO?.id_card_type === 'sns' || memberDTO?.id_card_type === 'centivo'
  return {
    isCigna,
    cignaUrl,
    hidePlanInfo: isCigna && memberDTO?.external_oe_injested === false
  }
}
